const storageKey = (productInstanceId) =>
  `grid_onboarding_${productInstanceId}`

export const readGridOnboardingSession = (productInstanceId) => {
  if (!productInstanceId) return null
  try {
    const raw = sessionStorage.getItem(storageKey(productInstanceId))
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const writeGridOnboardingSession = (productInstanceId, state) => {
  if (!productInstanceId) return
  sessionStorage.setItem(storageKey(productInstanceId), JSON.stringify(state))
}

export const clearGridOnboardingSession = (productInstanceId) => {
  if (!productInstanceId) return
  sessionStorage.removeItem(storageKey(productInstanceId))
}

/** Normalize generate-page-data API body to AIConfig paths (contact, reviews, about, …). */
export const normalizeGridAiPageData = (raw) => {
  if (!raw || typeof raw !== 'object') return {}
  if (
    raw.contact ||
    raw.reviews ||
    raw.about ||
    raw.booking ||
    raw.store ||
    raw.blog ||
    raw.faqs
  ) {
    return raw
  }
  if (raw.pageData && typeof raw.pageData === 'object') return raw.pageData
  if (raw.data && typeof raw.data === 'object') return raw.data
  if (raw.blocks && typeof raw.blocks === 'object') return raw.blocks
  return raw
}
